/* unplugin-vue-components disabled */import script from "./ShopItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopItem.vue?vue&type=script&setup=true&lang=js"

import "./ShopItem.vue?vue&type=style&index=0&id=709b39f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709b39f2"]])

export default __exports__